module.exports = __webpack_public_path__ + "img/arrow-next (2).8265d18a.svg";